export enum ResourceAuthEnum {
    //商品管理 (新增)
    DATA_M_AD = "gtm.m.ad",
    //商品管理 (编辑)
    DATA_M_ED = "gtm.m.ed",

    //客户管理 (新增)
    DATA_C_AD = "gtm.c.ad",
    //客户管理 (编辑)
    DATA_C_ED = "gtm.c.ed",
    //客户管理 (导入)
    DATA_C_IM = "gtm.c.ed.im",

    //供应商管理 (新增)
    DATA_S_AD = "gtm.s.ad",
    //供应商管理 (编辑)
    DATA_S_ED = "gtm.s.ed",
    //供应商管理 (导入)
    DATA_S_IM = "gtm.s.ed.im",


    //仓库管理 (新增)
    DATA_W_AD = "gtm.w.ad",
    //仓库管理 (编辑)
    DATA_W_ED = "gtm.w.ed",

    //外贸合同 (编辑 - 收汇)
    S_ED_SETTLE = "gtm.s.s.ed.pend-settle",
    //外贸合同 (编辑 - 提交审核)
    S_ED_SUBMIT = "gtm.s.s.ed.submit",
    //外贸合同 (编辑 - 转采购合同)
    S_ED_TRANS = "gtm.s.s.ed.trans",
    //外贸合同 (编辑 - 出库)
    S_ED_OUT = "gtm.s.s.ed.out",
    //外贸合同 (编辑 - 发运)
    S_ED_SHIP = "gtm.s.s.ed.ship",
    //外贸合同 (编辑 - 保存)
    S_ED_SAVE = "gtm.s.s.ed.save",
    //外贸合同 (编辑 - 附件上传)
    S_ED_IMPORT = "gtm.s.s.ed.im",
    //外贸合同 (编辑 - 总监审批)
    S_ED_APPROVE = "gtm.s.s.approve",
    //外贸合同 (编辑 - 财务审批)
    S_ED_FIN_APPROVE = "gtm.s.s.fin-approve",
    //外贸合同 (编辑 -导出)
    S_ED_EXPORT = "gtm.s.s.ex",
    //外贸合同 (新增)
    S_AD = "gtm.s.s.ad",
    //外贸合同 (编辑)
    S_ED = "gtm.s.s.ed",
    //外贸合同  (删除)
    S_DEL = "gtm.s.s.del",
    //外贸合同 (编辑 -结汇)
    S_ED_COLLECT = "gtm.s.s.ed.collect",
    //外贸合同 (编辑 -转报关单据)
    S_ED_TURNB = "gtm.s.s.ed.turnb",
    //外贸合同 (编辑 -弹窗-确认)
    S_ED_YES = "gtm.s.s.ed.yes",

    //采购合同 (编辑 - 提交审批)
    P_ED_SUBMIT = "gtm.p.p.ed.submit",
    //采购合同 (编辑 - 入库)
    P_ED_WAREHOUSE = "gtm.p.p.ed.warehouse",
    //采购合同 (编辑 - 导出采购合同)
    P_ED_EXPORT = "gtm.p.p.ed.ex",
    //采购合同 (编辑 - 保存)
    P_ED_SAVE = "gtm.p.p.ed.save",
    //采购合同 (编辑 - 财务审批)
    P_ED_FIN_APPROVE = "gtm.p.p.ed..fin-approve",
    //采购合同 (编辑 - 总监审批)
    P_ED_APPROVE = "gtm.p.p.ed.approve",
    //采购合同 (编辑 - 收汇)
    P_ED_SETTLE = "gtm.p.p.ed.settle",
    //采购合同 (新增)
    P_AD = "gtm.p.p.ad",
    //采购合同 (编辑)
    P_ED = "gtm.p.p.ed",
    //采购合同  (删除)
    P_DEL = "gtm.p.p.del",
    //采购合同  (商品-新增)
    P_ED_AD = "gtm.p.p.ed.ad",
    //采购合同  (附件-删除)
    P_ED_DEL = "gtm.p.p.ed.del",

    //出运管理  (编辑-商品删除)
    SH_ED_DEL = "gtm.sh.s.ed.del",
    //出运管理 (编辑 - 附件删除)
    SH_ED_DEL_APPENDIX = "gtm.sh.s.del-appendix",
    //出运管理 (编辑 - 保存)
    SH_ED_SAVE = "gtm.sh.s.ed.save",
    //出运管理 (编辑 - 结算)
    SH_ED_SETTLE = "gtm.sh.s.ed.bill",
    //出运管理 (编辑)
    SH_ED_ED = "gtm.sh.s.ed",
    //出运管理 (转运输单据)
    SH_ED_TURNY = "gtm.sh.s.ed.turny",
    //出运管理 (集装箱添加)
    SH_ED_CONTAINER = "gtm.sh.s.ed.container",
    //出运管理 (集装箱-删除)
    SH_ED_BOXDEL = "gtm.sh.s.ed.boxdel",

    //询价单 (编辑 -供应商- 转采购合同)
    I_ED_PURCHASE = "gtm.i.i.ed.purchase",
    //询价单 (编辑 -供应商- 编辑)
    I_ED_ED = "gtm.i.i.ed.ed",
    //询价单 (编辑 - 供应商-删除)
    I_ED_ED_DEL = "gtm.i.i.ed.del",
    //询价单 (编辑 - 供应商-出口报价)
    I_ED_ED_QUOTE = "gtm.i.i.ed.quote",
    //询价单 (编辑 - 供应商-新增)
    I_ED_ED_AD = "gtm.i.i.ed.ad",
    //询价单 (编辑 - 附件上传)
    I_ED_IMPORT = "gtm.i.i.ed.im",
    //询价单 (编辑 - 附件删除)
    I_ED_FILE_DEL = "gtm.i.i.ed.del-annex",
    //询价单 (编辑 -导出)
    I_ED_EXPORT = "gtm.i.i.ex",
    //询价单 (新增)
    I_AD = "gtm.i.i.ad",
    //询价单 (编辑)
    I_ED = "gtm.i.i.ed",
    //询价单  (删除)
    I_DEL = "gtm.i.i.del",


    //报价单 (编辑 - 转外贸合同)
    O_ED_TRANS = "gtm.o.o.ed.trans",
    //报价单 (编辑 - 提交审核)
    O_ED_SUBMIT = "gtm.o.o.ed.submit",
    //报价单 (编辑 - 财务审批)
    O_ED_FIN_APPROVE = "gtm.o.o.fin-approve",
    //报价单 (编辑 - 商品删除)
    O_ED_DEL = "gtm.o.o.ed.del",
    //报价单 (编辑 - 保存)
    O_ED_SAVE = "gtm.o.o.ed.save",
    //报价单 (编辑 - 总监审批)
    O_ED_APPROVE = "gtm.o.o.approve",
    //报价单 (编辑 -导出报价单)
    O_ED_EXPORT = "gtm.o.o.ed.ex",
    //报价单  (作废)
    O_ED_CANCEL = "gtm.o.o.ed.cancel",
    //报价单 (编辑 - 附件删除)
    O_ED_FILE_DEL = "gtm.o.o.ed.del-annex",
    //报价单 (编辑 - 商品新增)
    O_ED_AD_M = "gtm.o.o.ed-m",
    //报价单 (编辑)
    O_ED = "gtm.o.o.ed",
    //报价单  (删除)
    O_DEL = "gtm.o.o.del",
    //报价单 (商品导入模板 - 下载)
    O_M_DLOAD = "gtm.o.o.m.dload",
    //报价单 (商品详情 - 导入)
    O_M_IM = "gtm.o.o.m.im",
    //报价单 (商品详情 - 导出)
    O_M_EX = "gtm.o.o.m.ex",


    //信用证预警 (预警设置)
    W_L_WARN = "gtm.w.l.warn",
    //报关单预警 (预警设置)
    W_D_WARN = "gtm.w.d.warn",
    //应收账款预警 (预警设置)
    W_R_WARN = "gtm.w.r.warn",
    //应付账款预警 (预警设置)
    W_C_WARN = "gtm.w.c.warn",
    //文件预警 (预警设置)
    W_F_WARN = "gtm.w.f.warn",

    //  出口信用证 (新增)
    L_A_AD = "gtm.l.a.ad",
    //  出口信用证 (编辑)
    L_A_ED = "gtm.l.a.ed",
    //出口信用证 (导出)
    L_A_EX = "gtm.l.a.ex",
    //  出口信用证 (保存)
    L_A_ED_SAVE = "gtm.l.a.ed.save",
    //出口信用证 (附件删除)
    L_A_ED_DEL = "gtm.l.a.ed.del",

    //协议文件 (新增)
    A_A_AD = "gtm.a.a.ad",
    //协议文件 (编辑)
    A_A_ED = "gtm.a.a.ed",
    //协议文件 (导出)
    A_A_EX = "gtm.a.a.ex",
    //协议文件 (作废)
    A_A_DEL = "gtm.a.a.del",
    //协议文件 (保存)
    A_A_ED_SAVE = "gtm.a.a.ed.save",
    //协议文件 (附件删除)
    A_A_ED_DEL = "gtm.a.a.ed.del",

    //退税单据 (编辑)
    BACK_B_ED = "gtm.back.b.ed",
    //退税单据 (导出)
    BACK_B_EX = "gtm.back.b.ex",
    //退税单据 (作废)
    BACK_B_DEL = "gtm.back.b.del",
    //退税单据 (提交退税)
    BACK_B_ED_SUBBACK = "gtm.back.b.ed.subback",
    //退税单据 (退税)
    BACK_B_ED_BACK = "gtm.back.b.ed.back",
    //退税单据 (附件-删除)
    BACK_B_ED_DEL = "gtm.back.b.ed.del",

    //报关单据 (新增)
    CUS_B_AD = "gtm.cus.b.ad",
    //报关单据 (编辑)
    CUS_B_ED = "gtm.cus.b.ed",
    //报关单据 (作废)
    CUS_B_DEL = "gtm.cus.b.del",
    //报关单据 (导出)
    CUS_B_EX = "gtm.cus.b.ex",
    //报关单据 (单据生成)
    CUS_B_ED_OUT = "gtm.cus.b.ed.out",
    //报关单据 (编辑 - 提交审核)
    CUS_B_ED_SUB = "gtm.cus.b.ed.sub",
    //报关单据 (编辑 - 总监审批)
    CUS_B_ED_LEAD = "gtm.cus.b.ed.lead",
    //报关单据 (编辑 - 经理审核)
    CUS_B_ED_TUBE = "gtm.cus.b.ed.tube",
    //报关单据 (编辑 -转退税单据)
    CUS_B_ED_TURNT = "gtm.cus.b.ed.turnt",
    //报关单据  (保存)
    CUS_B_ED_SAVE = "gtm.cus.b.ed.save",
    //报关单据 (报关单-开始审核)
    CUS_B_ED_REVIEW = "gtm.cus.b.ed.review",
    //报关单据 (报关单-一键审核)
    CUS_B_ED_REVIEW1 = "gtm.cus.b.ed.review1",
    //报关单据 (附件-删除)
    CUS_B_ED_DEL = "gtm.cus.b.ed.del",

    //运输单据 (新增)
    SHI_B_AD = "gtm.shi.b.ad",
    //运输单据 (编辑)
    SHI_B_ED = "gtm.shi.b.ed",
    //运输单据 (作废)
    SHI_B_DEL = "gtm.shi.b.del",
    //运输单据 (导出)
    SHI_B_EX = "gtm.shi.b.ex",
    //运输单据 (单据生成)
    SHI_B_ED_OUT = "gtm.shi.b.ed.out",
    //运输单据 (编辑 - 提交审核)
    SHI_B_ED_SUB = "gtm.shi.b.ed.sub",
    //运输单据 (编辑 - 经理审核)
    SHI_B_ED_TUBE = "gtm.shi.b.ed.tube",
    //运输单据 (编辑 - 总监审批)
    SHI_B_ED_LEAD = "gtm.shi.b.ed.lead",
    //运输单据  (保存)
    SHI_B_ED_SAVE = "gtm.shi.b.ed.save",
    //运输单据 (提单管理-删除)
    SHI_B_ED_TDDEL = "gtm.shi.b.ed.tddel",
    //运输单据 (提单管理-保存)
    SHI_B_ED_TDSAVE = "gtm.shi.b.ed.tdsave",
    //运输单据 (附件-上传)
    SHI_B_ED_IM = "gtm.shi.b.ed.im",
    //运输单据 (附件-删除)
    SHI_B_ED_DEL = "gtm.shi.b.ed.del",

    //合同进程表 (导出)
    J_A_EX = "gtm.j.a.ex",
    //付款查询 (导出)
    P_A_EX = "gtm.p.a.ex",
    //收款查询 (导出)
    R_A_EX = "gtm.r.a.ex",
    //外贸合同查询 (导出)
    S_A_EX = "gtm.s.a.ex",
    //采购合同查询 (导出)
    C_A_EX = "gtm.c.a.ex",

    //报价成功率 (导出)
    B_A_EX = "gtm.b.a.ex",
    //合同利润率分析 (导出)
    G_A_EX = "gtm.g.a.ex",
    //客户分析 (导出)
    M_A_EX = "gtm.m.a.ex",
    //业务预警 (导出)
    W_A_EX = "gtm.w.a.ex",

    // //客户管理 (上传)
    // C_ED_IM = "gtm.c.ed.im",
    // //供应商 (上传)
    // S_ED_IM = "gtm.s.ed.im",
}